import * as React from "react";

const SvgArrowDown = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m3 6.5 5 5 5-5H3Z" />
  </svg>
);

export default SvgArrowDown;
